export default __webpack_public_path__ + "static/media/cover-background.be7d96bf.jpg";